<script setup lang="ts">
/**
 * QrPlaceholder
 *
 * Renders a dummy 2D barcode (QR-code style) placeholder SVG.
 * Used in all label preview sections to visually represent where the
 * real QR code would appear on a printed label, without generating
 * an actual barcode via any library.
 */
withDefaults(
  defineProps<{
    /** Width/height in pixels – defaults to 80 */
    size?: number;
  }>(),
  { size: 80 },
);
</script>

<template>
  <!-- eslint-disable vue/max-attributes-per-line -->
  <div class="shrink-0">
    <svg
      :width="size"
      :height="size"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="100" height="100" fill="white" stroke="#D1D5DB" />
      <!-- Top-left finder -->
      <rect x="4" y="4" width="24" height="24" stroke="#1F2937" stroke-width="3" />
      <rect x="10" y="10" width="12" height="12" fill="#1F2937" />
      <!-- Top-right finder -->
      <rect x="72" y="4" width="24" height="24" stroke="#1F2937" stroke-width="3" />
      <rect x="78" y="10" width="12" height="12" fill="#1F2937" />
      <!-- Bottom-left finder -->
      <rect x="4" y="72" width="24" height="24" stroke="#1F2937" stroke-width="3" />
      <rect x="10" y="78" width="12" height="12" fill="#1F2937" />
      <!-- Data modules (simulated) -->
      <rect x="36" y="8" width="5" height="5" fill="#9CA3AF" />
      <rect x="48" y="16" width="5" height="5" fill="#9CA3AF" />
      <rect x="56" y="8" width="5" height="5" fill="#9CA3AF" />
      <rect x="8" y="38" width="5" height="5" fill="#9CA3AF" />
      <rect x="18" y="44" width="5" height="5" fill="#9CA3AF" />
      <rect x="36" y="38" width="5" height="5" fill="#9CA3AF" />
      <rect x="50" y="42" width="5" height="5" fill="#9CA3AF" />
      <rect x="60" y="38" width="5" height="5" fill="#9CA3AF" />
      <rect x="74" y="44" width="5" height="5" fill="#9CA3AF" />
      <rect x="84" y="50" width="5" height="5" fill="#9CA3AF" />
      <rect x="38" y="58" width="5" height="5" fill="#9CA3AF" />
      <rect x="52" y="64" width="5" height="5" fill="#9CA3AF" />
      <rect x="64" y="58" width="5" height="5" fill="#9CA3AF" />
      <rect x="74" y="74" width="5" height="5" fill="#9CA3AF" />
      <rect x="84" y="82" width="5" height="5" fill="#9CA3AF" />
      <rect x="40" y="76" width="5" height="5" fill="#9CA3AF" />
      <rect x="54" y="84" width="5" height="5" fill="#9CA3AF" />
      <rect x="66" y="78" width="5" height="5" fill="#9CA3AF" />
    </svg>
  </div>
</template>
